import { Typography } from '@mui/material';

export const Title = ({ title, subtitle }: { title: string; subtitle: string }) => (
  <>
    <Typography sx={{ typography: { md: 'h1', xs: 'h3' } }}>{title}</Typography>
    <Typography variant="h7" fontFamily="Lanna" component="div" lineHeight={1.25}>
      <Typography component="span" sx={{ color: 'errorDark.main' }}>
        *
      </Typography>
      {subtitle}
    </Typography>
  </>
);
